import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type CartState = {
  cartCount: number;
};

const initialState: CartState = {
  cartCount: 0
};

export const CartSlice = createSlice({
  name: 'cartState',
  initialState,
  reducers: {
    setCartCount: (state, action: PayloadAction<number>) => {
      state.cartCount = action.payload;
    }
  }
});

export const { setCartCount } = CartSlice.actions;

export default CartSlice.reducer;
